//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  data: function data() {
    return {
      date: [],
      dialogShow: false,
      content_Val: [],
      type: ''
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, type) {
      console.log("data===", data);
      this.content_Val = [];
      this.type = type;
      this.content_Val = data;
      this.dialogShow = true;
    }
  }
};